import { render, staticRenderFns } from "./TeamInfoCard.vue?vue&type=template&id=2961c0ac&"
import script from "./TeamInfoCard.vue?vue&type=script&lang=js&"
export * from "./TeamInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports